import React from 'react';
import {KeyboardDatePicker} from "@material-ui/pickers";
import {TextField, MenuItem, Select} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import withStyles from "@material-ui/core/styles/withStyles";

import { FormattedMessage } from 'react-intl';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

import { Alert } from '@material-ui/lab';
import moment from "moment";
import AppStore from "../AppStore";


const styles = theme => ({
    paper: {
        marginTop: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    languageRow: {
        textAlign: 'right'
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    submitError: {
        margin: theme.spacing(2, 0, 0, 0),
    }
});

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            <Link color="inherit" href="https://www.venicepms.com/" target={"_blank"}>
                venicepms.com
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
    );
}



class LoginPage extends React.Component
{
    static contextType = AppStore;

    constructor(props) {
        super(props);

        // Ej: NDIxODd8MjAyMC0wMy0xOXxlcw%3D%3D => 42187|2020-03-19|es
        // Ej: NDIxODd8MjAyMC0wMy0xOXxlbg%3D%3D => 42187|2020-03-19|en
        const params = new URLSearchParams(window.location.search);

        // Testing
        //params.set('b', 'NDIxODd8MjAyMC0wMy0xOXxlbg%3D%3D');
        //43559|2021-02-16
        //params.set('b', 'NDM1NTl8MjAyMS0wMi0xNg%3D%3D');


        const deepLinkParts = params.has('b')
            ? atob(decodeURIComponent(params.get('b'))).split("|")
            : null;

        // TODO: Aca poner el del browser?
        // TODO: El deepLink implica menos seguridad ya que las credenciales estan en la url. Que lo use el que quiera
        this.defaultLanguage = params.has('l')
            ? params.get('l')
            : 'es';

        // Ojo que aca no se tiene acceso al this.context
        this.tenant = props.match.params['tenant'];
        this.resort = props.match.params['resort']

        this.state = {
            isSubmitting: false,
            error: '',

            // Form
            bookingCode: deepLinkParts ? deepLinkParts[0] : '',
            arrivalDate: deepLinkParts ? moment(deepLinkParts[1]) : null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    setSubmitting(isSubmitting) {
        this.setState({
            isSubmitting: isSubmitting,
            error: isSubmitting ? '' : this.state.error
        })
    }

    setError(errorMessage) {
        this.setState({
            error: errorMessage
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        const values = this.state;
        const appStore = this.context;

        if ( !moment(values.arrivalDate).isValid() ) {
            this.setError(appStore.formatMessage("app.login.invalid-date"));
            return;
        }

        this.setSubmitting(true)

        appStore
            .authenticate({
                resortCode: this.resort,
                bookingCode: values.bookingCode,
                arrivalDate: moment(values.arrivalDate).format('YYYY-MM-DD'),
            })
            .then(({ok, error}) => {
                this.setSubmitting(false)

                let {match, location, history} = this.props;

                if ( ok ) {
                    let { from } = location.state || { from: { pathname: `/${match.params['tenant']}/${match.params['resort']}/home` } };
                    history.replace(from);
                }
                else {
                    this.setError(error);
                }
            })
            .catch(() => {
                this.setSubmitting(false)
                this.setError('Se ha producido un error. Revise la conexión de internet y vuelva a intentarlo');
            });
    }

    render() {
        const { classes } = this.props;
        const appStore = this.context;

        return (

            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <Box mb={5}>
                        <img
                            src={appStore.getResortData()['options']['urlLogo']}
                            alt={""}
                            width={"192"}
                        />
                    </Box>
                    <form onSubmit={this.handleSubmit}>
                        <AppStore.Consumer>
                            {appStore =>
                                <div className={classes.languageRow}>
                                    <Select
                                        value={appStore.language ? appStore.language : this.defaultLanguage}
                                        onChange={(event) => appStore.setLanguage(event.target.value)}
                                    >
                                        {Object.keys(appStore.languageList).map((lang) => (
                                            <MenuItem key={lang} value={lang}>{lang.toUpperCase()}</MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            }
                        </AppStore.Consumer>

                        <TextField
                            type={"text"}
                            label={<FormattedMessage id="app.login.booking-code"/>}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth

                            value={this.state.bookingCode}
                            onChange={(event) => {this.setState({bookingCode: event.target.value})}}
                        />

                        <KeyboardDatePicker
                            label={<FormattedMessage id="app.login.booking-arrival"/>}
                            clearable
                            inputVariant="outlined"
                            placeholder={appStore.formatMessage('app.format.date-small-label')}
                            margin="normal"
                            format="DD/MM/yyyy"
                            required
                            fullWidth

                            value={this.state.arrivalDate}
                            onChange={(moment) => {this.setState({arrivalDate: moment})}}
                        />

                        {this.state.error &&
                            <Alert
                                severity="error"
                                className={classes.submitError}>
                                {this.state.error}
                            </Alert>
                            }

                        <Button
                            size={"large"}
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disabled={this.state.isSubmitting}
                        >
                            <FormattedMessage id="app.login.login"/>
                        </Button>
                    </form>
                </div>
                <Box mt={8}>
                    <Copyright />
                </Box>
            </Container>
        );
    }
}

export default withStyles(styles)(LoginPage);
